// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"142":"f7dc48de","443":"f38fda8b","715":"61413069","769":"511614b7"}[chunkId] + ".css";
};